<template>
  <div id="app" style="height: 100%;width: 100%;">
    <template v-if="$route.name != 'h5'">
      <div class="head">
        <div class="head_box">
          <div class="head_logo">
            <img src="https://file.aavisa.com/browser-upload-file/huyilogo.png.png">
          </div>
          <div class="menu">
            <div class="menu_item" @click="goLink('/')" :class="$route.name == 'index' ? 'active' : ''">首页
            </div>
            <!-- <div class="menu_item" @click="goLink('/country')"
						:class="$route.name == 'country' ? 'active' : ''">签证国家
					</div> -->
            <el-popover placement="bottom" trigger="hover" width="550" style="padding: 0;" popper-class="popper_class"
              :visible-arrow="false">
              <div class="">
                <el-tabs type="border-card" tab-position="left" style="height: 20rem;">
                  <el-tab-pane style="height: 15.9375r" v-for="(_item_,_index_) in dataList" :key="_index_">
                    <div slot="label" class="tab_pane_label">
                      <span class="tab_pane_span"></span>
                      <span class="tab_pane_text">{{_item_.name}}</span>
                    </div>
                    <div class="" style="height: 100%;margin: 0 auto;position: relative;">
                      <img
                        style="width: 1.125rem;height: 1.125rem;right: 0.3125rem;top:50%;transform: translate(-50%, -50%);position: absolute;z-index: 100;"
                        src="https://file.aavisa.com/browser-upload-file/d0c89cb8-200e-481b-82c7-631bfdac9b03.jpg">
                      <el-select style="width: 100%;" v-model="searchTxet" filterable remote
                        :remote-method="SeachCountry" placeholder="搜索办理签证的国家或地区" @change="changeSeach"
                        :popperAppendToBody="false">
                        <el-option style="z-index: 100;" v-for="item in SeachCountryList" :key="item.id"
                          :label="item.zh_name" :value="item">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="" style="width: 100%;display: flex;flex-wrap: wrap;">
                      <div
                        style="white-space: nowrap;width: 25%;margin-top: 0.625rem;font-size: 0.875rem;cursor: pointer;font-weight: 600;"
                        @click="goLink('/detail?id='+ items.id +'&County='+items.zh_name)"
                        v-for="(items,indexs) in dataList[_index_].list" :key="items.id">
                        {{items.zh_name}}
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>

              <div class="menu_item" slot="reference" @click="goLink('/country')"
                :class="($route.name == 'country' || $route.name == 'detail') ? 'active' : ''">
                签证国家</div>
            </el-popover>

            <div class="menu_item" @click="goLink('/Insurance')" :class="$route.name == 'Insurance' ? 'active' : ''">
              保险商城</div>
            <div class="menu_item" @click="goLink('/generate')" :class="$route.name == 'generate' ? 'active' : ''">
              签证工具</div>
            <div class="menu_item" @click="goLink('/news')"
              :class="($route.name == 'news' || $route.name ==  'newsdetails') ? 'active' : ''">
              签证资讯</div>


            <div class="menu_item" @click="goLink('/aboutus')" :class="$route.name == 'aboutus' ? 'active' : ''">
              关于我们</div>

            <div class="menu_item" @click="goLink('/orderlist')" :class="$route.name == 'orderlist' ? 'active' : ''"
              v-if="isLogin">
              我的订单</div>


            <el-popover placement="bottom" trigger="hover" width="215" style="padding: 0;" popper-class="popper_class"
              v-if="isLogin" :visible-arrow="false">
              <div class="personcenter_box">
                <div class="head">
                  <el-image src="https://file.aavisa.com/browser-upload-file/e111230e-3433-430e-ae9f-be32787537ec.jpg"
                    fit="fill" style="width: 100%;height: 100%;"></el-image>
                </div>
                <div class="" style="color: #333333;text-align: center;">
                  {{Contacts}}
                </div>

                <div class="personcenter_btn">
                  <div class="" @click="goLink('/personcenter')">
                    个人中心
                  </div>
                  <div class="" @click="delCookie">
                    退出登录
                  </div>
                </div>
              </div>

              <div class="menu_item" slot="reference" :class="$route.name == 'personcenter' ? 'active' : ''"
                @click="goLink('/personcenter')">
                个人中心
                <i class="el-icon-arrow-down"></i>
              </div>
            </el-popover>

          </div>
          <el-button type="primary" @click="login" v-if="!isLogin">登录</el-button>


        </div>



      </div>
      <router-view v-if="!$route.meta.keep_alive"></router-view>
      <div class="footer">
        <div class="footer_main">
          <div class="footer_label">
            <span @click="goLink('/')">首页</span>
            <span @click="goLink('/country')">签证国家</span>
            <span @click="goLink('/Insurance')">保险商城</span>
            <span @click="goLink('/generate')">签证工具</span>
            <span @click="goLink('/news')">签证资讯</span>
            <span @click="goLink('/privacy')">隐私条款</span>
            <span @click="goLink('/visanotice')">签证须知</span>
            <span @click="goLink('/aboutus')">关于我们</span>
            <span @click="goLink('/contactus')">联系我们</span>
          </div>

          <div class="footer_phone">
            全国统一服务电话：0755 82990111
          </div>
          <div class="footer_filings">
            掌上签 © 2016-2023 www.aavisa.com All Rights Reserved 深圳掌上办公技术有限公司 粤ICP备18098296号 &nbsp;
            <!-- <el-image style="width: 1.25rem;height: 1.6875rem;" src="../static/image/1、签证首页切图/首页底部安全图标.png">
					</el-image> -->

            <a target="_blank"
              href="https://xyt.xcc.cn/getpcInfo?sn=1569961948018073600&certType=8&url=*.aavisa.com&language=CN">
              <img src="https://program.xinchacha.com/xyt/xcc_small_ssl.png"
                style="width:1.1rem;height:1.3rem;vertical-align:-webkit-baseline-middle">
            </a>
          </div>

          <div class="footer_pay">
            <el-image src="https://file.aavisa.com/browser-upload-file/1b80a55d-f17e-4751-b2ac-89d34c39d04b.jpg">
            </el-image>
          </div>
        </div>
      </div>

      <login ref="login"></login>
    </template>
    <template v-else>
      <router-view v-if="!$route.meta.keep_alive"></router-view>
    </template>
  </div>
</template>

<script>
  import login from './components/login/login.vue'
  export default {
    components: {
      login,

    },
    data() {
      return {
        isLogin: false,
        st: '',
        searchTxet: '',
        SeachCountryList: [],
        trigger: false,
        Contacts: '小翼',
        dataList: [{
          name: '亚洲',
          value: 'Asia',
          list: []
        }, {
          name: '欧洲',
          value: 'Europe',
          list: []
        }, {
          name: '美洲',
          value: 'America',
          list: []
        }, {
          name: '大洋洲',
          value: 'Oceania',
          list: [],
        }, {
          name: '非洲',
          value: 'Africa',
          list: []
        }],
      };
    },

    created() {
      this.GetCountrys()

      this.st = setInterval(() => {
        if (cookie.get('auth') && cookie.get('MemberId') && cookie.get("PcMemberId")) {
          this.move()
          this.isLogin = true
          this.Contacts = decodeURIComponent(cookie.get('Contacts'))
          clearImmediate(this.st)
        }
      }, 1000)
    },

    beforeMount() {
      // console.log('beforeMount')
      // if (this.$route.query.code) {
      // 	console.log(this.$route.query.code,'created')
      // 	this.move()
      // 	this.CheckCodeLogin(this.$route.query.code)
      // }

    },

    Mounted() {
      console.log('Mounted')

    },

    watch: {
      $route(to, from) {
        // if (this.$route.query.code) {
        // 	console.log(this.$route.query.code,'$route')
        // 	this.move()
        // 	this.CheckCodeLogin(this.$route.query.code)
        // }
        this.st = setInterval(() => {
          if (cookie.get('auth') && cookie.get('MemberId') && cookie.get("PcMemberId")) {
            this.move()
            this.isLogin = true
            clearImmediate(this.st)
          }
        }, 2000)
      }
    },
    methods: {

      GetCountrys() {
        let {
          continentsList,
          dataList
        } = this
        let that = this;
        let GetCountrys = function (Zone, index = null) {
          that.$api.GetCountrys({
            Zone
          }).then(res => {
            let {
              data,
              status
            } = res.data
            if (status == 200) {
              if (index == 0 || index) {
                dataList[index].list = data
              }
            }
          })
        }
        for (let i = 0; i < dataList.length; i++) {
          GetCountrys(dataList[i].value, i)
        }
      },
      changeSeach(value) {
        console.log(value)
        this.$router.push(`/detail?id=${value.id}&County=${value.zh_name}`)
      },

      SeachCountry(value) {
        this.$api.SeachCountry({
          keys: value
        }).then(res => {
          let {
            data,
            status
          } = res.data;
          if (status == 200) {
            console.log(data)
            this.SeachCountryList = data.data;
          }
        })
      },

      login() {
        this.isLogin = this.$refs.login.checkLogin()
      },


      goLink(url) {
        this.$router.push(url)
      },

      delCookie() {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie =
            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        }
        if (cookies.length > 0) {
          for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            var domain = location.host.substr(location.host.indexOf("."));
            document.cookie =
              name +
              "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
              domain;
          }
        }
        this.isLogin = false;
        this.$message.success("退出成功！");
        location.reload();
        // this.$router.push('')
      },

      // CheckCodeLogin(code) {
      // 	// if(!this.$refs.login.checkLogin()) return false
      // 	if((cookie.get('auth') && cookie.get('MemberId'))) return false
      // 	this.$api.CheckCodeLogin({
      // 		Code: code
      // 	}).then(res => {
      // 		console.log(res)
      // 		if (res.data.result) {
      // 			cookie.set('auth', res.data.data.token)
      // 			cookie.set('MemberId', res.data.data.Id)
      // 			cookie.set('storeId', res.data.data.StoreId)
      // 			cookie.set('Contacts', res.data.data.Contacts)
      // 			this.Contacts = cookie.get('Contacts')
      // 			this.$router.push('')
      // 		} else {
      // 			this.$router.push('')
      // 			this.$message.error(res.data.message)
      // 		}
      // 	}).catch(err => {
      // 		this.$router.push('')
      // 		this.$message.error(res.data.message)
      // 	})
      // },

      /***取消滑动限制***/
      move() {
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = ''; //出现滚动条
        document.removeEventListener("touchmove", mo, false);
      }
    },
    updated() {


    }
  }

</script>

<style lang='less' scoped>
  .personcenter_box {
    width: 13.4375rem;
    height: 18.875rem;
    background-color: #fff;
    overflow: hidden;

    .head {
      width: 4.5625rem;
      height: 4.5625rem;
      margin: 40px auto 0.625rem;
      border-radius: 50%;
      overflow: hidden;
    }

    .personcenter_btn {
      width: 7.5rem;
      height: 5.9375rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin: 1.25rem auto 0;

      &>div {
        width: 100%;
        height: 2.5rem;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      &>div:nth-child(1) {
        color: #fff;
        background-color: #599FFF;
      }

      &>div:nth-child(2) {
        color: #999;
        background-color: fff;
        border: 1px solid #999999;
        box-sizing: border-box;
      }
    }
  }

  .head {
    height: 4.375rem;
    background-color: #fff;
    border-bottom: 1px solid #eeeeee;

    .head_box {
      width: 75rem;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .head_logo {

      height: 100%;
      display: flex;
      align-items: center;

      &>img {
        height: 80%;

      }
    }

    .menu {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 7.825rem;

      .menu_item {
        margin: 0 2.05rem;
        text-decoration: none;
        color: #000;
        position: relative;
        cursor: pointer;
        font-size: 1rem;
        white-space: nowrap;
      }



    }

    .active {
      color: #599fff !important;
    }

    .active:before {
      content: "";
      display: block;
      height: 0.15625rem;
      width: 80%;
      background: #599fff;
      position: absolute;
      bottom: -0.8rem;
      left: 50%;
      transform: translate(-50%, 0%);
      border-radius: 5px;

    }

    .el-button {
      background-color: #599fff !important;
      border-color: #599fff !important;
      padding-left: 2.125rem;
      padding-right: 2.125rem;
    }
  }

  .footer {
    width: 100%;
    height: 18.3125rem;
    background-color: #363636;
    position: relative;

    .footer_main {
      width: 75rem;
      height: 11.6875rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .footer_label {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #aaaaaa;
        font-size: 1rem;
      }

      .footer_label>span {
        cursor: pointer;
      }

      .footer_phone {
        color: #aaaaaa;
        margin: 2rem auto 1.875rem;
      }

      .footer_filings {
        color: #aaaaaa;
        margin-bottom: 2.125rem;
        display: flex;
        align-items: center;
        justify-content: center;

        &>a {
          line-height: 1rem;
        }

        .el-image {
          margin-left: 0.8125rem;
        }
      }

      .footer_pay {
        width: 33.8125rem;
        height: 2.25rem;
        margin: 0 auto;

        .el-image {
          height: 100%;
        }
      }
    }
  }

  .el-tabs {
    border-radius: 14px;

    /deep/ .el-tabs__item {
      padding: 0 !important;
      text-align: left !important;
    }

    /deep/ .el-tabs__nav {
      width: 5.4375rem !important;
      height: 3.25rem !important;

      .el-tabs__item {
        height: 100%;
      }
    }

    /deep/ .el-tabs__content {
      height: 90%;
      overflow-y: auto;
    }


    .tab_pane_label {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 0.0625rem;

      .tab_pane_span {
        color: #FFF;
        display: inline-block;
        background-color: rgba(0, 0, 0, 0);
        width: 0.1875rem;
        height: 1rem;
        border-radius: 14px;
        margin: 0 0.5rem;
      }

      .tab_pane_text {
        color: #999999 !important;
      }
    }

    /deep/ .el-tabs__item {
      transition: none !important;
    }

    .is-active {
      .tab_pane_label {
        background-color: #569af7;
      }

      .tab_pane_span {
        background-color: #fff;
      }

      .tab_pane_text {
        color: #fff !important;
      }
    }


  }

</style>

<style>
  /* 写完隐藏 */
  /* 	::-webkit-scrollbar {
		width: 0;
	} */

  ::-webkit-scrollbar {
    width: 0.45rem !important;
  }

  ::-webkit-scrollbar-track {
    background-color: #F0F0F0;
    /* background-color: rgba(0,0,0,0) !important; */
    border-radius: 10px;
    width: 0.25rem !important;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #599fff;
  }

  html {
    font-size: 16px;
  }

  .popper_class {
    padding: 0 !important;
    margin: 1.625rem 0 0 0 !important;
    border-radius: 10px !important;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0) !important;
    border: none !important;
    /* z-index: 99999; */
  }

  /* 解决element-ui的table表格控件表头与内容列不对齐问题 */
  .el-table th.gutter {
    display: table-cell !important;
  }

  /* 用来设置当前页面element全局table 选中某行时的背景色*/
  .el-table__body tr.current-row>td {
    background-color: #ecf5ff !important;
    /* color: #f19944; */
    /* 设置文字颜色，可以选择不设置 */
  }

  /* 用来设置当前页面element全局table 鼠标移入某行时的背景色*/
  .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #fafafa;
    /* color: #f19944; */
    /* 设置文字颜色，可以选择不设置 */
  }

</style>
<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: #f0f0f0;
    margin: 0px !important;
  }

  .flex {
    display: flex;
  }

  .m20 {
    margin: 20px !important;
  }

  .mt10 {
    margin-top: 10px !important;
  }

  .mt20 {
    margin-top: 20px !important;
  }

  .mt50 {
    margin-top: 50px !important;
  }

  .mt100 {
    margin-top: 100px !important;
  }

  .ml10 {
    margin-left: 10px !important;
  }

  .ml20 {
    margin-left: 20px !important;
  }

  .mr20 {
    margin-right: 20px !important;
  }

  .mr50 {
    margin-right: 50px !important;
  }

  .mr80 {
    margin-right: 50px !important;
  }

  .w100 {
    width: 100%;
  }

  .bgf {
    background-color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue